"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ellipsize = _interopRequireDefault(require("ellipsize"));
var _recharts = require("recharts");
var _DoughnutLabel = _interopRequireDefault(require("./DoughnutLabel.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var LENGTH_THRESHOLD = 23;
var DoughnutLabel = function DoughnutLabel(props) {
  var cx = props.cx,
    cy = props.cy,
    innerRadius = props.innerRadius,
    outerRadius = props.outerRadius,
    startAngle = props.startAngle,
    endAngle = props.endAngle,
    name = props.name,
    fill = props.fill,
    multiline = props.multiline;
  return /*#__PURE__*/_react["default"].createElement(_DoughnutLabel["default"], {
    className: "doughnut-lbl"
  }, /*#__PURE__*/_react["default"].createElement(_recharts.Sector, {
    cx: cx,
    cy: cy,
    innerRadius: innerRadius,
    outerRadius: outerRadius,
    startAngle: startAngle,
    endAngle: endAngle,
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("text", {
    x: cx,
    y: cy,
    dy: "0.35em",
    dominantBaseline: "middle",
    textAnchor: "middle",
    fill: "#222"
  }, (0, _ellipsize["default"])(name, LENGTH_THRESHOLD)), multiline && /*#__PURE__*/_react["default"].createElement("text", {
    x: cx,
    y: cy,
    dy: 40,
    className: "multine",
    textAnchor: "middle",
    fill: "#222"
  }, (0, _ellipsize["default"])(multiline, LENGTH_THRESHOLD)));
};
DoughnutLabel.defaultProps = {
  multiline: ''
};
DoughnutLabel.propTypes = {
  cx: _propTypes["default"].number.isRequired,
  cy: _propTypes["default"].number.isRequired,
  fill: _propTypes["default"].string.isRequired,
  startAngle: _propTypes["default"].number.isRequired,
  endAngle: _propTypes["default"].number.isRequired,
  outerRadius: _propTypes["default"].number.isRequired,
  innerRadius: _propTypes["default"].number.isRequired,
  name: _propTypes["default"].string.isRequired,
  multiline: _propTypes["default"].string
};
var _default = exports["default"] = DoughnutLabel;